import { render, staticRenderFns } from "./ReligionAdd.vue?vue&type=template&id=6d049e11&"
import script from "./ReligionAdd.vue?vue&type=script&lang=js&"
export * from "./ReligionAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports